import { render, staticRenderFns } from "./AccountTopUp.vue?vue&type=template&id=a81b4f02&"
import script from "./AccountTopUp.vue?vue&type=script&lang=js&"
export * from "./AccountTopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports